import React from 'react';
import classNames from 'classnames';
import ArrowIcon from '@icons/arrow-medium-gray.svg';
import PagesIndicator from './PagesIndicator';
import PagesContent from './PagesContent';
import './Pages.scss';

type PagesProps = {
    hidden?: boolean;
    className?: string;
    label?: string;
    isFullWidthChildren?: boolean;
    children: any;
    activePage?: number;
};

type PagesState = {
    pageIndex: number;
    pageCount: number;
};

export class Pages extends React.Component<PagesProps, PagesState> {
    pagesElement: HTMLDivElement | null | undefined;

    constructor(props: PagesProps) {
        super(props);

        this.state = {
            pageIndex: 0,
            pageCount: props.children.length
        };

        this.goToIndex = this.goToIndex.bind(this);
        this.goToPrevious = this.goToPrevious.bind(this);
        this.goToNext = this.goToNext.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.activePage &&
            this.props.activePage !== prevProps.activePage
        ) {
            this.setState({ pageIndex: this.props.activePage });
        }
    }

    goToIndex(pageIndex) {
        this.setState({
            pageIndex
        });
    }

    goToNext() {
        this.setState(({ pageIndex }) => ({
            pageIndex:
                pageIndex < this.props.children.length - 1
                    ? pageIndex + 1
                    : this.props.children.length - 1
        }));
    }

    goToPrevious() {
        this.setState(({ pageIndex }) => ({
            pageIndex: pageIndex === 0 ? 0 : pageIndex - 1
        }));
    }

    render() {
        const classes = classNames(
            {
                'b-pages': true,
                'is-hidden':
                    typeof this.props.hidden !== 'undefined'
                        ? this.props.hidden
                        : false
            },
            this.props.className
        );

        const pageCount = Array.isArray(this.props.children)
            ? this.props.children.length
            : 1;

        return (
            <div
                className={classes}
                ref={e => {
                    this.pagesElement = e;
                }}
            >
                <img
                    src={ArrowIcon}
                    className="awc-previous-arrow pages__previous-arrow"
                    onClick={this.goToPrevious}
                    role="button"
                    tabIndex={0}
                    style={{ display: pageCount < 2 ? 'none' : 'block' }}
                />
                <div className="pages__content-column">
                    <PagesContent
                        pageIndex={this.state.pageIndex}
                        isFullWidthChildren={this.props.isFullWidthChildren}
                    >
                        {this.props.children}
                    </PagesContent>
                    <PagesIndicator
                        pageCount={pageCount}
                        activeItemIndex={this.state.pageIndex}
                        onItemClick={this.goToIndex}
                    />
                </div>
                <img
                    src={ArrowIcon}
                    className="awc-next-arrow pages__next-arrow"
                    role="button"
                    tabIndex={0}
                    onClick={this.goToNext}
                    style={{ display: pageCount < 2 ? 'none' : 'block' }}
                />
            </div>
        );
    }
}
